import { createStylesParams } from '@wix/tpa-settings';

import { badgeStylesParams, BadgeStylesParams } from './Badge/stylesParams';
import {
  backgroundAndBordersStylesParams,
  BackgroundAndBordersStylesParams,
} from './BackgroundAndBorders/stylesParams';
import {
  dispatchInfoStylesParams,
  DispatchInfoStylesParams,
} from './DispatchInfo/stylesParams';
import {
  fulfillmentPickerStylesParams,
  FulfillmentPickerStylesParams,
} from './FulfillmentPicker/stylesParams';
import { imageStylesParams, ImageStylesParams } from './Image/stylesParams';
import {
  locationButtonStylesParams,
  LocationButtonStylesParams,
} from './LocationButton/stylesParams';
import { textStylesParams, TextStylesParams } from './Text/stylesParams';
import {
  viewCartStylesParams,
  ViewCartStylesParams,
} from './OrderButton/stylesParams';
import {
  navigationStylesParams,
  NavigationStylesParams,
} from './Navigation/stylesParams';

export type DesignStylesParams = TextStylesParams &
  BadgeStylesParams &
  ImageStylesParams &
  BackgroundAndBordersStylesParams &
  FulfillmentPickerStylesParams &
  DispatchInfoStylesParams &
  NavigationStylesParams &
  LocationButtonStylesParams &
  ViewCartStylesParams;

export const designStylesParams = createStylesParams<DesignStylesParams>({
  ...textStylesParams,
  ...badgeStylesParams,
  ...imageStylesParams,
  ...backgroundAndBordersStylesParams,
  ...fulfillmentPickerStylesParams,
  ...dispatchInfoStylesParams,
  ...locationButtonStylesParams,
  ...viewCartStylesParams,
  ...navigationStylesParams,
});
